/*eslint-disable*/
define('paychex.app.messages/services/ParseMarkupService',['jquery', 'lodash'], function ($, _) {

    'use strict';

    return function ParseMarkupService() {
        /*
         * set up the mapping elements
         */
        var mapElement = {
                a: 'a',
                img: 'img',
                p: 'div',
                span: 'span',
                textflow: 'div'
            },
            cssAttrs = {
                color: 'color',
                fontSize: 'font-size',
                fontStyle: 'font-style',
                fontWeight: 'font-weight',
                width: 'width',
                height: 'height',
                textDecoration: 'text-decoration',
                backgroundColor: 'background-color',
                clearFloats: 'clear',
                textAlpha: 'opacity'
            },
            domAttrs = {
                source: 'src',
                href: 'href',
                target: 'target',
                styleName: 'class'
            },
            formatters = {fontSize: function (val) {
                return String(parseInt(val, 10)) + 'px';
            }},
            /*
             * Adding attributes with provided mapping
             */
            buildAttr = function (fmlRoot, outRoot) {
                _.forOwn(fmlRoot.attributes, function buildAttrFn (attr) {
                    var cssAttr = cssAttrs[attr.name],
                        domAttr = domAttrs[attr.name],
                        value = (formatters[attr.name] || _.identity)(attr.value, fmlRoot),
                        newUrl;
                    if (cssAttr !== undefined) {
                        $(outRoot).css(cssAttr, value);
                    } else if (domAttr !== undefined) {
                        if (value.indexOf('downloadMessageAttachment') !== -1) {
                            $(outRoot).attr(domAttr, '/landing_remote/' + value);
                            $(outRoot).attr('target', '_blank');
                        } else if (value.indexOf('/landing_remote/uiCache/images/message/') !== -1 && window.jspVars.isPhoneGap) {
                            // specifically added for phonegap
                            newUrl = value.replace('/landing_remote/uiCache', window.jspVars.phoneGapRoot + '/landing_static');
                            $(outRoot).attr(domAttr, newUrl);
                        } else {
                            $(outRoot).attr(domAttr, value);
                        }
                    }
                });
            },

            /*
             * Processing node according to the situation
             * of its child node. Note: text node is not
             * counted as a node with length = 0.
             */
            convertFlex = function (fmlRoot, outRoot) {
                fmlRoot.each(function iterate () {
                    var child = $(this).contents(),
                        element;
                    // current node is element
                    if (this.nodeType === 1) {
                        element = document.createElement(mapElement[this.nodeName.toLowerCase()]);
                        buildAttr(this, element);
                        if (child.length > 0) {
                            convertFlex(child, element);
                        }
                        $(outRoot).append(element);
                    } else if (this.nodeType === Node.TEXT_NODE) {
                        // current node is text node
                        $(outRoot).append(this.nodeValue);
                    }
                });
            };

        /*
         * return the obj
         */
        return {
            addCustomFormatter: function (key, fn) {
                formatters[key] = fn;
            },
            parseMarkup: function (fml) {
                try {
                    var $html = $($.parseXML(fml)),
                        output = document.createElement('div');
                    convertFlex($html.contents(), output);
                    return $(output).html();
                } catch (Exception) {
                    return fml;
                }
            }
        };
    };
});
/*eslint-enable*/
;
